import APIModel from "../APIModel";

export default class Invoices extends APIModel {
  private readonly resourceUrl: string;

  constructor() {
    super();
    this.resourceUrl = "order_invoices";
  }

  async getData(params: object): Promise<any> {
    return await this.http.get(`${this.resourceUrl}`, params);
  }

  async getForEdit(id: number): Promise<any> {
    return await this.http.get(`${this.resourceUrl}/${id}/edit`);
  }

  async getList(): Promise<any> {
    return await this.http.get(`${this.resourceUrl}/list`, {});
  }

  async getOrderInvoices(order_id: number): Promise<any> {
    return await this.http
      .ignoreErrorHandler(500, 404, 400, 401)
      .get(`${this.resourceUrl}/get_order_invoices/${order_id}`, {});
  }

  async geFileForPreview(order_id: number, params: any = {}): Promise<any> {
    return await this.http
      .ignoreErrorHandler(404, 500)
      .get(`${this.resourceUrl}/${order_id}/pdf_preview`, params);
  }

  async getFileForPrint(order_id: number): Promise<any> {
    return await this.http
      .ignoreErrorHandler(404, 500)
      .get(`${this.resourceUrl}/${order_id}/pdf_print`, {});
  }

  async getFileForPrintAta(order_id: number): Promise<any> {
    return await this.http
      .ignoreErrorHandler(404, 500)
      .get(`${this.resourceUrl}/${order_id}/pdf_print`, { is_ata: true });
  }
  async edit(id: number, payload: object): Promise<any> {
    return await this.http
      .ignoreErrorHandler(422)
      .post(`${this.resourceUrl}/${id}?_method=PATCH`, payload);
  }

  async create(payload: any): Promise<any> {
    return await this.http
      .ignoreErrorHandler(422)
      .post(`${this.resourceUrl}`, payload);
  }

  async delete(id: any): Promise<any> {
    return await this.http.delete(`${this.resourceUrl}`, { id });
  }
}
